<script lang="ts">
</script>

<div class="header-container">
  <img src="assets/Pokédex_logo.webp" alt="Pokedex logo" />
</div>

<style>
  .header-container {
    text-align: center;
    margin: 3rem 0;
  }
</style>
